"use strict";
exports.__esModule = true;
//# sourceMappingURL=article.js.map